import React from 'react';
import Yup from 'yup';
import Section from '../common/Section';
import SectionHeader from '../common/SectionHeader';
import Form from '../form';
import CancelButton from '../form/controls/CancelButton';
import ClientService from '../../services/ClientService';

const schema = Yup.object().shape({
  company: Yup
    .object({
      sfCompanyId: Yup.string().required("Company Salesforce ID required"),
      name: Yup.string().required("Company name required")
    }),
  contact: Yup
    .object({
      sfContactId: Yup.string().required("Contact Salesforce ID required"),
      name: Yup.string().required("Contact name required"),
      email: Yup.string().required("Email required"),
      phone: Yup.string().required("Phone required")
    })
});

class ClientEdit extends React.Component {
  constructor(props) {
    super(props);

    this.saveChanges = this.saveChanges.bind(this);
    this.delete = this.delete.bind(this);

    this.state = {
      client: {
        id: 0,
        attributes: {
          company: {},
          contact: {},
          whiteGloves: null,
          technician: [],
          qaEngineer: [],
          surveyManager: [],
          projectManager: [],
          doNotAssign: []
        }
      }
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    if (id && id > 0) {
      ClientService.getById(id).then(result => {
        this.setState({ client: Object.assign({}, result) });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.client.id !== nextProps.client.id) {
      this.setState({ client: Object.assign({}, nextProps.client) });
    }
  }

  delete() {
  }

  saveChanges(values) {

    const current = { ...this.state.client };
    Object.assign(current.attributes, values);

    if (current.id > 0) {
      return ClientService.save(current);
    }

    return ClientService.create(current);
  }

  render() {

    const editMode = this.state.client.id > 0;

    return (
      <React.Fragment>
        <SectionHeader title="Edit">
          <a className="delete" onClick={this.delete} title="Delete" data-icon="&#xe912;">Delete</a>
        </SectionHeader>
        <Section className="edit-page">
          <Form
            initialValues={{ ...this.state.client.attributes }}
            enableReinitialize={true}
            validationSchema={schema}
            redirect={this.props.returnPath}
            onSubmit={this.saveChanges}>

            <Form.Errors />

            <h2>ID {this.state.client.id}</h2>

            <Form.FieldGroup label="Company ID*">
              <Form.Input
                name="company.sfCompanyId"
                readOnly={editMode}
                placeholder="Type company SalesForce ID" />
              <Form.FieldError name="company.sfCompanyId" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Company name*">
              <Form.Input
                name="company.name"
                readOnly={editMode}
                placeholder="Type company name" />
              <Form.FieldError name="company.name" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Contact ID*">
              <Form.Input
                name="contact.sfContactId"
                placeholder="Type contact SalesForce ID" />
              <Form.FieldError name="contact.sfContactId" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Contact name*">
              <Form.Input
                name="contact.name"
                placeholder="Type contact name" />
              <Form.FieldError name="contact.name" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Contact email*">
              <Form.Input
                name="contact.email"
                type="email"
                placeholder="Type contact email" />
              <Form.FieldError name="contact.email" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Contact phone*">
              <Form.Input
                name="contact.phone"
                placeholder="Type contact phone" />
              <Form.FieldError name="contact.phone" />
            </Form.FieldGroup>

            <Form.FieldGroup label="Preferred technician">
              <Form.UserMultiSelect
                name="technician"
                roles={[7]} />
            </Form.FieldGroup>

            <Form.FieldGroup label="Preferred QA">
              <Form.UserMultiSelect
                name="qaEngineer"
                roles={[4]} />
            </Form.FieldGroup>

            <Form.FieldGroup label="Preferred survey programmer">
              <Form.UserMultiSelect
                name="surveyManager"
                roles={[2]} />
            </Form.FieldGroup>

            <Form.FieldGroup label="Preferred project manager">
              <Form.UserMultiSelect
                name="projectManager"
                roles={[1, 5, 6]} />
            </Form.FieldGroup>

            <Form.FieldGroup label="Do Not Assign">
              <Form.UserMultiSelect
                name="doNotAssign" />
            </Form.FieldGroup>

            <Form.FieldGroup label="White gloves">
              <Form.Input
                name="whiteGloves"
                type="checkbox" />
            </Form.FieldGroup>

            <fieldset className="buttons-container">
              <button type="submit">Save</button>
              <CancelButton path={this.props.returnPath} />
            </fieldset>
          </Form>
        </Section>
      </React.Fragment>
    );
  }
}

ClientEdit.defaultProps = {
  returnPath: "/requirements"
}

export default ClientEdit;



// WEBPACK FOOTER //
// ./src/components/clients/ClientEdit.js